export default [
  {
    path: '/webpay',
    name: 'webpay',
    component: () => import('@/apps/webpay/pages/WebpayPage.vue')
  }
]
